module.exports = __webpack_public_path__ + "assets/img/news (21).9e5c23a4.png";